import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsJobtitle from 'graphql/fields/FieldsJobtitle'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query jobtitle( ${ HelperGraphql.createFields( fields ) } ) {
		jobtitle( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsJobtitle}
		}
	}
`);

